module.exports = __webpack_public_path__ + "img/modal_bg.3d1b9298.png";